var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSameSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#paint0_linear_12977_133295)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 38C14 38 22.5014 39.5 28 39.5C33.4986 39.5 42 38 42 38",
    stroke: "url(#paint1_linear_12977_133295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V24.5",
    stroke: "url(#paint2_linear_12977_133295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 17.5V24.5",
    stroke: "url(#paint3_linear_12977_133295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12977_133295",
    x1: 59,
    y1: 40.5,
    x2: 3,
    y2: -6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC683",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12977_133295",
    x1: 15.2923,
    y1: 38.6717,
    x2: 16.3202,
    y2: 33.0927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12977_133295",
    x1: 17.5462,
    y1: 20.6347,
    x2: 18.6624,
    y2: 20.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12977_133295",
    x1: 38.0462,
    y1: 20.6347,
    x2: 39.1624,
    y2: 20.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSameSmile);
export default __webpack_public_path__ + "static/media/same_smile.492ae4e4c198eef96df1ae02ee20f819.svg";
export { ForwardRef as ReactComponent };